module.exports = __webpack_public_path__ + "static/assets/d858fd6624df047931f9004ca3bf4d91.svg";